import React, { Component } from "react";
import { connect } from "react-redux";
import { PageHeader, Row, Col, Input, InputNumber, Select, AutoComplete, Spin, Tag, Tooltip, Popover, Modal, Alert, message } from "antd";
import {
    ArrowLeftOutlined,
    ArrowUpOutlined,
    ArrowDownOutlined,
    ArrowRightOutlined,
    DeleteOutlined,
    PlusOutlined,
    CopyOutlined,
    SaveOutlined,
    EyeOutlined,
    UnorderedListOutlined,
    TableOutlined,
    SettingOutlined,
} from "@ant-design/icons";
import { DynamicCardForm, ButtonItem, TourItem } from "../../../../Components/Items";
import ModalPdfCMMS from "../componentes/ModalPdfCMMS";
import certificadoCMMSPdf from "../../../../Pdf/cmms/certificadoCMMSPdf";
import { cmmsPost } from "../cmmsComun";
import moment from "moment";
import { TIPOS_COLUMNA, llave, celdaVacia, columnaNueva, seccionChecklist, seccionTabla, rangoCelda, textoRango, sumarMeses, anchoTabla, MAX_ANCHO_TABLA } from "./certificadoComun";
import "../cmms.css";

const { Option } = Select;

// Editor de una plantilla de certificado (formato F-SE-14). Se abre con
// history.push("/panel/cmmsPlantillaCertificado", { id }) o {} para una nueva.
// El estado guarda todo con "key" por renglon; al guardar se quitan.

const mover = (lista, i, d) => {
    const j = i + d;
    if (j < 0 || j >= lista.length) return lista;
    const c = [...lista];
    [c[i], c[j]] = [c[j], c[i]];
    return c;
};

const conLlaves = (p) => ({
    ...p,
    camposEquipo: (p.camposEquipo || []).map((c) => ({ key: llave(), etiqueta: c.etiqueta, opciones: (c.opciones || []).join(", ") })),
    secciones: (p.secciones || []).map((s) => ({
        ...s,
        key: llave(),
        items: (s.items || []).map((it) => ({ ...it, key: llave() })),
        columnas: (s.columnas || []).map((c) => ({ ...c, key: llave() })),
        filas: (s.filas || []).map((f) => ({ ...f, key: llave(), celdas: (s.columnas || []).map((_, j) => ({ ...celdaVacia(), ...((f.celdas || [])[j] || {}) })) })),
    })),
});

const sinLlaves = (d) => ({
    ...d,
    camposEquipo: d.camposEquipo.map(({ key, ...c }) => ({ etiqueta: c.etiqueta, opciones: String(c.opciones || "").split(",").map((o) => o.trim()).filter(Boolean) })),
    secciones: d.secciones.map(({ key, ...s }) => ({
        ...s,
        items: s.items.map(({ key: _k, ...it }) => it),
        columnas: s.columnas.map(({ key: _k, ...c }) => c),
        filas: s.filas.map(({ key: _k, ...f }) => f),
    })),
});

const PLANTILLA_NUEVA = () => ({
    clave: "",
    nombre: "",
    revision: "",
    vigenciaMeses: 6,
    etiquetaPatron: "Simulador paciente",
    tiposEquipoIds: [],
    patronesIds: [],
    camposEquipo: [],
    secciones: [seccionChecklist(), seccionTabla()],
    dictamenAprobado:
        "Los valores entregados en los diferentes parámetros por parte del equipo se encuentran dentro del rango de tolerancia de acuerdo al Manual de Servicio del equipo, por lo que se determina que el equipo se encuentra funcional y en condiciones aptas para su uso.",
    dictamenNoAprobado:
        "Uno o más de los valores entregados por el equipo se encuentran fuera del rango de tolerancia de acuerdo al Manual de Servicio del equipo, por lo que se determina que el equipo NO se encuentra en condiciones aptas para su uso hasta que se corrija.",
});

class PlantillaCertificado extends Component {
    state = { cargando: true, guardando: false, id: this.props.location?.state?.id || null, d: PLANTILLA_NUEVA(), tipos: [], patrones: [], pegar: null, vistaPrevia: false, cambios: false, openTour: false };

    componentDidMount() {
        this.cargar();
    }

    cargar = async () => {
        this.setState({ cargando: true });
        try {
            // Todos (tambien deshabilitados) para que los ya elegidos se vean con su nombre.
            const [rTipos, rPatrones, rPlantilla] = await Promise.all([
                cmmsPost(this.props, "selectTiposEquipo", { valor: 3 }),
                cmmsPost(this.props, "selectEquiposPatronCMMS", { todos: true }),
                this.state.id ? cmmsPost(this.props, "datosPlantillaCertificadoCMMS", { id: this.state.id }) : null,
            ]);
            const cambios = { tipos: rTipos.data.success === 2 ? rTipos.data.tipos : [], patrones: rPatrones.data.success === 2 ? rPatrones.data.equiposPatron : [] };
            if (rPlantilla) {
                if (rPlantilla.data.success === 2) cambios.d = conLlaves(rPlantilla.data.plantilla);
                else message.error(rPlantilla.data.message || "No se encontró la plantilla");
            }
            this.setState(cambios);
        } catch (error) {
            console.log(error);
            message.error("No se pudo cargar");
        } finally {
            this.setState({ cargando: false });
        }
    };

    // ─── Edicion ────────────────────────────────────────────────────────────
    set = (cambios) => this.setState((s) => ({ d: { ...s.d, ...cambios }, cambios: true }));
    setSeccion = (i, f) => this.setState((s) => ({ d: { ...s.d, secciones: s.d.secciones.map((x, j) => (j === i ? { ...x, ...(typeof f === "function" ? f(x) : f) } : x)) }, cambios: true }));

    setItem = (i, k, cambios) => this.setSeccion(i, (s) => ({ items: s.items.map((it, n) => (n === k ? { ...it, ...cambios } : it)) }));
    setColumna = (i, j, cambios) => this.setSeccion(i, (s) => ({ columnas: s.columnas.map((c, n) => (n === j ? { ...c, ...cambios } : c)) }));
    setCelda = (i, k, j, cambios) =>
        this.setSeccion(i, (s) => ({ filas: s.filas.map((f, n) => (n === k ? { ...f, celdas: f.celdas.map((c, m) => (m === j ? { ...c, ...cambios } : c)) } : f)) }));
    agregarColumna = (i) => this.setSeccion(i, (s) => ({ columnas: [...s.columnas, columnaNueva()], filas: s.filas.map((f) => ({ ...f, celdas: [...f.celdas, celdaVacia()] })) }));
    quitarColumna = (i, j) => this.setSeccion(i, (s) => ({ columnas: s.columnas.filter((_, n) => n !== j), filas: s.filas.map((f) => ({ ...f, celdas: f.celdas.filter((_, n) => n !== j) })) }));
    moverColumna = (i, j, d) => this.setSeccion(i, (s) => ({ columnas: mover(s.columnas, j, d), filas: s.filas.map((f) => ({ ...f, celdas: mover(f.celdas, j, d) })) }));
    agregarFila = (i, copiaDe) =>
        this.setSeccion(i, (s) => {
            const nueva = copiaDe !== undefined ? { ...s.filas[copiaDe], key: llave(), celdas: s.filas[copiaDe].celdas.map((c) => ({ ...c })) } : { key: llave(), etiqueta: "", celdas: s.columnas.map(() => celdaVacia()) };
            const filas = [...s.filas];
            filas.splice(copiaDe !== undefined ? copiaDe + 1 : filas.length, 0, nueva);
            return { filas };
        });

    // Pegar caracteristicas: una por renglon; "Grupo: texto" pone el grupo.
    aplicarPegado = () => {
        const { indice, texto } = this.state.pegar || {};
        const lineas = String(texto || "")
            .split(/\r?\n/)
            .map((l) => l.replace(/^\s*\d+[.)-]\s*/, "").trim())
            .filter(Boolean)
            .map((l) => {
                const m = l.match(/^([^:]{1,30}):\s*(.+)$/);
                return { key: llave(), grupo: m ? m[1].trim() : "", texto: m ? m[2].trim() : l };
            });
        if (lineas.length) this.setSeccion(indice, (s) => ({ items: [...s.items.filter((it) => String(it.texto || "").trim()), ...lineas] }));
        this.setState({ pegar: null });
    };

    guardar = async () => {
        const d = this.state.d;
        if (!String(d.nombre || "").trim()) return message.warning("Escriba el nombre del certificado (ej. Monitor de signos vitales)");
        this.setState({ guardando: true });
        try {
            const ruta = this.state.id ? "editarPlantillaCertificadoCMMS" : "agregarPlantillaCertificadoCMMS";
            const res = await cmmsPost(this.props, ruta, { ...sinLlaves(d), id: this.state.id });
            if (res.data.success === 2) {
                message.success("Plantilla guardada");
                if (!this.state.id) this.props.history.replace("/panel/cmmsPlantillaCertificado", { id: res.data.id });
                this.setState({ id: res.data.id, cambios: false });
            } else message.error(res.data.message || "No se pudo guardar");
        } catch (error) {
            console.log(error);
            message.error("No se pudo guardar");
        } finally {
            this.setState({ guardando: false });
        }
    };

    salir = () => {
        if (!this.state.cambios) return this.props.history.goBack();
        Modal.confirm({ title: "Hay cambios sin guardar", content: "¿Salir sin guardar?", okText: "Salir", cancelText: "Seguir editando", onOk: () => this.props.history.goBack() });
    };

    // Vista previa del PDF con la plantilla vacia (sin valores capturados).
    vistaPrevia = () => {
        const d = sinLlaves(this.state.d);
        const hoy = moment().format("YYYY-MM-DD");
        return certificadoCMMSPdf({
            empresa: {},
            impresion: {},
            ordenServicio: "",
            ingeniero: "",
            certificado: {
                ...d,
                codigo: "",
                fecha: hoy,
                vigenciaHasta: sumarMeses(hoy, d.vigenciaMeses || 6),
                patrones: this.state.patrones.filter((p) => (d.patronesIds || []).includes(p._id)),
                equipo: {},
                camposEquipo: d.camposEquipo.map((c) => ({ ...c, valor: "" })),
                secciones: d.secciones.map((s) => ({
                    ...s,
                    items: s.items.map((it) => ({ ...it, antes: null, despues: null })),
                    filas: s.filas.map((f) => ({ ...f, celdas: f.celdas.map((c, j) => ({ ...c, ...(() => { const r = rangoCelda(s.columnas[j], c); return { rangoMin: r?.min ?? null, rangoMax: r?.max ?? null }; })() })) })),
                })),
                dictamen: "",
                cumple: null,
            },
        });
    };

    // ─── Render ─────────────────────────────────────────────────────────────

    renderDatos() {
        const d = this.state.d;
        return (
            <DynamicCardForm title="Datos del certificado" xs={24} lg={14}>
                <Row gutter={12}>
                    <Col xs={24} md={9}>
                        <div className="cmms-etiqueta-campo">Clave del formato</div>
                        <Input placeholder="Ej. F.SE.14.MSV" value={d.clave} onChange={(e) => this.set({ clave: e.target.value })} />
                    </Col>
                    <Col xs={24} md={15}>
                        <div className="cmms-etiqueta-campo">Nombre (se imprime bajo el título) *</div>
                        <Input placeholder="Ej. Monitor de signos vitales" value={d.nombre} onChange={(e) => this.set({ nombre: e.target.value })} />
                    </Col>
                    <Col xs={24} md={9} style={{ marginTop: 10 }}>
                        <div className="cmms-etiqueta-campo">Revisión</div>
                        <Input placeholder="Ej. Rev. 00 · Septiembre 2025" value={d.revision} onChange={(e) => this.set({ revision: e.target.value })} />
                    </Col>
                    <Col xs={12} md={6} style={{ marginTop: 10 }}>
                        <Tooltip title="El certificado vence estos meses después de su fecha (en el F-SE-14, 6).">
                            <div className="cmms-etiqueta-campo">Vigencia (meses)</div>
                        </Tooltip>
                        <InputNumber min={1} max={120} style={{ width: "100%" }} value={d.vigenciaMeses} onChange={(v) => this.set({ vigenciaMeses: v || 6 })} />
                    </Col>
                    <Col xs={12} md={9} style={{ marginTop: 10 }}>
                        <div className="cmms-etiqueta-campo">Título del equipo patrón</div>
                        <AutoComplete style={{ width: "100%" }} options={[{ value: "Simulador paciente" }, { value: "Analizador" }]} value={d.etiquetaPatron} onChange={(etiquetaPatron) => this.set({ etiquetaPatron })} />
                    </Col>
                    <Col xs={24} style={{ marginTop: 10 }}>
                        <Tooltip title="Al emitir un certificado desde un servicio se proponen primero las plantillas del tipo de activo del equipo.">
                            <div className="cmms-etiqueta-campo">Se usa para los tipos de activo</div>
                        </Tooltip>
                        <Select mode="multiple" allowClear showSearch optionFilterProp="children" style={{ width: "100%" }} placeholder="Ninguno (se elige a mano)" value={d.tiposEquipoIds} onChange={(tiposEquipoIds) => this.set({ tiposEquipoIds })}>
                            {this.state.tipos
                                .filter((t) => t.estado === 1 || (d.tiposEquipoIds || []).includes(t._id))
                                .map((t) => (
                                    <Option key={t._id} value={t._id}>
                                        {t.estado === 1 ? t.nombre : `${t.nombre} (deshabilitado)`}
                                    </Option>
                                ))}
                        </Select>
                    </Col>
                    <Col xs={24} style={{ marginTop: 10 }}>
                        <Tooltip title="Se proponen al emitir el certificado; el ingeniero puede cambiarlos. Se dan de alta en Certificados › Equipos patrón.">
                            <div className="cmms-etiqueta-campo">Equipos patrón sugeridos</div>
                        </Tooltip>
                        <Select mode="multiple" allowClear showSearch optionFilterProp="children" style={{ width: "100%" }} placeholder="Ninguno" value={d.patronesIds} onChange={(patronesIds) => this.set({ patronesIds })}>
                            {this.state.patrones
                                .filter((p) => p.activo || (d.patronesIds || []).includes(p._id))
                                .map((p) => (
                                    <Option key={p._id} value={p._id}>
                                        {p.activo ? p.nombre : `${p.nombre} (deshabilitado: no se propondrá)`}
                                    </Option>
                                ))}
                        </Select>
                    </Col>
                </Row>
            </DynamicCardForm>
        );
    }

    renderCamposEquipo() {
        const campos = this.state.d.camposEquipo;
        const setCampo = (i, cambios) => this.set({ camposEquipo: campos.map((c, j) => (j === i ? { ...c, ...cambios } : c)) });
        return (
            <DynamicCardForm title="Datos extra del equipo" xs={24} lg={10}>
                <div className="cmms-ayuda">Además de marca, modelo y serie (vienen del equipo). Ej. Anestésico: Sevorane, Isoflurane... · Forma de onda: Monofásico, Bifásico. Sin opciones se escribe libre.</div>
                {campos.map((c, i) => (
                    <div key={c.key} style={{ display: "flex", gap: 6, marginBottom: 6 }}>
                        <Input placeholder="Dato (ej. Anestésico)" value={c.etiqueta} onChange={(e) => setCampo(i, { etiqueta: e.target.value })} style={{ flex: 2 }} />
                        <Input placeholder="Opciones separadas por coma (opcional)" value={c.opciones} onChange={(e) => setCampo(i, { opciones: e.target.value })} style={{ flex: 3 }} />
                        <ButtonItem lessTime type="default" size="small" rojo icon={<DeleteOutlined />} onClick={() => this.set({ camposEquipo: campos.filter((_, j) => j !== i) })} />
                    </div>
                ))}
                <ButtonItem lessTime type="dashed" icon={<PlusOutlined />} onClick={() => this.set({ camposEquipo: [...campos, { key: llave(), etiqueta: "", opciones: "" }] })}>
                    Agregar dato
                </ButtonItem>
            </DynamicCardForm>
        );
    }

    encabezadoSeccion(s, i) {
        const total = this.state.d.secciones.length;
        return {
            title: (
                <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
                    {s.tipo === "tabla" ? <TableOutlined /> : <UnorderedListOutlined />}
                    {`${i + 1}. ${s.titulo || (s.tipo === "tabla" ? "Tabla de mediciones" : "Checklist")}`}
                    <Tag style={{ marginLeft: 4 }}>{s.tipo === "tabla" ? "Mediciones" : "Antes / después"}</Tag>
                </span>
            ),
            headerRight: (
                <span style={{ display: "flex", gap: 4 }}>
                    <ButtonItem lessTime type="default" size="small" icon={<ArrowUpOutlined />} disabled={i === 0} onClick={() => this.set({ secciones: mover(this.state.d.secciones, i, -1) })} />
                    <ButtonItem lessTime type="default" size="small" icon={<ArrowDownOutlined />} disabled={i === total - 1} onClick={() => this.set({ secciones: mover(this.state.d.secciones, i, 1) })} />
                    <ButtonItem lessTime type="default" size="small" rojo icon={<DeleteOutlined />} disabled={total === 1} onClick={() => this.set({ secciones: this.state.d.secciones.filter((_, j) => j !== i) })} />
                </span>
            ),
        };
    }

    renderChecklist(s, i) {
        return (
            <DynamicCardForm key={s.key} xs={24} {...this.encabezadoSeccion(s, i)}>
                <Input value={s.titulo} placeholder="Título (ej. Características a inspeccionar)" onChange={(e) => this.setSeccion(i, { titulo: e.target.value })} style={{ marginBottom: 10, maxWidth: 420 }} />
                <div className="cmms-ayuda">Cada característica se califica antes y después del mantenimiento: cumple, no cumple o no aplica. El grupo (NIBP, SpO2, Alarmas...) es opcional y se imprime en negritas.</div>
                {s.items.map((it, k) => (
                    <div key={it.key} style={{ display: "flex", gap: 6, marginBottom: 5, alignItems: "center" }}>
                        <span style={{ width: 26, color: "#7a8794", fontSize: 12 }}>{k + 1}.</span>
                        <Input placeholder="Grupo" value={it.grupo} onChange={(e) => this.setItem(i, k, { grupo: e.target.value })} style={{ width: 150 }} />
                        <Input placeholder="Característica (ej. Estado de manguera y brazalete NIBP)" value={it.texto} onChange={(e) => this.setItem(i, k, { texto: e.target.value })} style={{ flex: 1 }} />
                        <ButtonItem lessTime type="default" size="small" icon={<ArrowUpOutlined />} disabled={k === 0} onClick={() => this.setSeccion(i, (x) => ({ items: mover(x.items, k, -1) }))} />
                        <ButtonItem lessTime type="default" size="small" icon={<ArrowDownOutlined />} disabled={k === s.items.length - 1} onClick={() => this.setSeccion(i, (x) => ({ items: mover(x.items, k, 1) }))} />
                        <ButtonItem lessTime type="default" size="small" rojo icon={<DeleteOutlined />} onClick={() => this.setSeccion(i, (x) => ({ items: x.items.filter((_, n) => n !== k) }))} />
                    </div>
                ))}
                <div style={{ display: "flex", gap: 8 }}>
                    <ButtonItem lessTime type="dashed" icon={<PlusOutlined />} onClick={() => this.setSeccion(i, (x) => ({ items: [...x.items, { key: llave(), grupo: "", texto: "" }] }))}>
                        Agregar característica
                    </ButtonItem>
                    <ButtonItem type="link" onClick={() => this.setState({ pegar: { indice: i, texto: "" } })}>
                        Pegar varias (una por renglón)
                    </ButtonItem>
                </div>
            </DynamicCardForm>
        );
    }

    renderEditorColumna(s, i, c, j) {
        const total = s.columnas.length;
        return (
            <div key={c.key} className="cmms-columna-certificado">
                <div style={{ display: "flex", gap: 4, marginBottom: 4 }}>
                    <Input size="small" placeholder="Nombre (ej. Sistólica)" value={c.nombre} onChange={(e) => this.setColumna(i, j, { nombre: e.target.value })} />
                    <ButtonItem lessTime type="default" size="small" icon={<ArrowLeftOutlined />} disabled={j === 0} onClick={() => this.moverColumna(i, j, -1)} />
                    <ButtonItem lessTime type="default" size="small" icon={<ArrowRightOutlined />} disabled={j === total - 1} onClick={() => this.moverColumna(i, j, 1)} />
                    <ButtonItem lessTime type="default" size="small" rojo icon={<DeleteOutlined />} disabled={total === 1} onClick={() => this.quitarColumna(i, j)} />
                </div>
                <Select size="small" style={{ width: "100%", marginBottom: 4 }} value={c.tipo} onChange={(tipo) => this.setColumna(i, j, { tipo })}>
                    {TIPOS_COLUMNA.map((t) => (
                        <Option key={t.value} value={t.value} title={t.ayuda}>
                            {t.label}
                        </Option>
                    ))}
                </Select>
                {c.tipo === "medicion" && (
                    <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
                        <Input size="small" placeholder="Unidad" value={c.unidad} onChange={(e) => this.setColumna(i, j, { unidad: e.target.value })} style={{ width: 70 }} />
                        <InputNumber size="small" min={0} placeholder="± tol." value={c.tolerancia} onChange={(v) => this.setColumna(i, j, { tolerancia: v ?? null })} style={{ width: 70 }} />
                        <Select size="small" value={c.toleranciaTipo} onChange={(toleranciaTipo) => this.setColumna(i, j, { toleranciaTipo })} style={{ width: 92 }}>
                            <Option value="pct">%</Option>
                            <Option value="abs">unidades</Option>
                        </Select>
                        <Tooltip title="Tope del rango (ej. SpO2: 100). El mínimo nunca baja de 0.">
                            <InputNumber size="small" placeholder="Máx." value={c.limiteMaximo} onChange={(v) => this.setColumna(i, j, { limiteMaximo: v ?? null })} style={{ width: 70 }} />
                        </Tooltip>
                    </div>
                )}
            </div>
        );
    }

    renderEditorCelda(s, i, f, k, c, j) {
        const col = s.columnas[j];
        const celda = f.celdas[j] || celdaVacia();
        if (col.tipo === "texto") return <Input size="small" value={celda.texto} placeholder="Texto" onChange={(e) => this.setCelda(i, k, j, { texto: e.target.value })} />;
        if (col.tipo !== "medicion") return <span style={{ color: "#9aa7b4", fontSize: 12 }}>{col.tipo === "okError" ? "Ok / Error al certificar" : "Se escribe al certificar"}</span>;
        const rango = textoRango(col, celda);
        const propio = celda.minimo !== null || celda.maximo !== null || celda.tolerancia !== null;
        return (
            <div style={{ display: "flex", gap: 3, alignItems: "center" }}>
                <InputNumber size="small" placeholder="Al certificar" value={celda.establecido} onChange={(v) => this.setCelda(i, k, j, { establecido: v ?? null })} style={{ width: 96 }} />
                <Popover
                    trigger="click"
                    title="Rango de este renglón"
                    content={
                        <div style={{ width: 240 }}>
                            <div className="cmms-ayuda">Solo si este renglón no usa la tolerancia de la columna. Mínimo y máximo (del manual del fabricante) mandan sobre la tolerancia.</div>
                            <div className="cmms-etiqueta-campo">Tolerancia propia (±)</div>
                            <InputNumber size="small" min={0} style={{ width: "100%" }} value={celda.tolerancia} onChange={(v) => this.setCelda(i, k, j, { tolerancia: v ?? null })} />
                            <div style={{ display: "flex", gap: 6, marginTop: 6 }}>
                                <div>
                                    <div className="cmms-etiqueta-campo">Mínimo</div>
                                    <InputNumber size="small" value={celda.minimo} onChange={(v) => this.setCelda(i, k, j, { minimo: v ?? null })} />
                                </div>
                                <div>
                                    <div className="cmms-etiqueta-campo">Máximo</div>
                                    <InputNumber size="small" value={celda.maximo} onChange={(v) => this.setCelda(i, k, j, { maximo: v ?? null })} />
                                </div>
                            </div>
                        </div>
                    }
                >
                    <Tooltip title={rango ? `Rango: ${rango}` : "Sin rango: solo se registra la medida"}>
                        <ButtonItem lessTime type="default" size="small" blanco={!propio} icon={<SettingOutlined />} />
                    </Tooltip>
                </Popover>
                <span style={{ fontSize: 11, color: "#7a8794", whiteSpace: "nowrap" }}>{rango}</span>
            </div>
        );
    }

    renderTabla(s, i) {
        return (
            <DynamicCardForm key={s.key} xs={24} {...this.encabezadoSeccion(s, i)}>
                <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 10 }}>
                    <Input value={s.titulo} placeholder="Título (ej. NIBP)" onChange={(e) => this.setSeccion(i, { titulo: e.target.value })} style={{ width: 260 }} />
                    <Tooltip title="Encabezado de la primera columna (Modo, Preset, Prueba realizada...).">
                        <Input value={s.etiquetaFila} placeholder="Primera columna (ej. Modo)" onChange={(e) => this.setSeccion(i, { etiquetaFila: e.target.value })} style={{ width: 200 }} />
                    </Tooltip>
                </div>
                <div className="cmms-etiqueta-campo">Columnas</div>
                <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 10 }}>
                    {s.columnas.map((c, j) => this.renderEditorColumna(s, i, c, j))}
                    {anchoTabla(s.columnas) + 3 <= MAX_ANCHO_TABLA && (
                        <ButtonItem lessTime type="dashed" icon={<PlusOutlined />} onClick={() => this.agregarColumna(i)}>
                            Columna
                        </ButtonItem>
                    )}
                </div>
                {anchoTabla(s.columnas) > MAX_ANCHO_TABLA && (
                    <Alert
                        type="warning"
                        showIcon
                        style={{ marginBottom: 10 }}
                        message="Esta tabla no cabe en la hoja: cada medición ocupa 3 columnas en el PDF (establecido, rango y entregado). Quite columnas o divídala en dos tablas."
                    />
                )}
                <div className="cmms-etiqueta-campo">Renglones (valor establecido: vacío = lo escribe el ingeniero al certificar)</div>
                <div style={{ overflowX: "auto" }}>
                    <table className="cmms-tabla-editor">
                        <thead>
                            <tr>
                                <th style={{ minWidth: 170 }}>{s.etiquetaFila || "Modo"}</th>
                                {s.columnas.map((c) => (
                                    <th key={c.key} style={{ minWidth: 150 }}>
                                        {c.nombre || "Columna"} {c.unidad ? `(${c.unidad})` : ""}
                                    </th>
                                ))}
                                <th style={{ width: 120 }} />
                            </tr>
                        </thead>
                        <tbody>
                            {s.filas.map((f, k) => (
                                <tr key={f.key}>
                                    <td>
                                        <Input size="small" value={f.etiqueta} placeholder="Ej. Adulto" onChange={(e) => this.setSeccion(i, (x) => ({ filas: x.filas.map((y, n) => (n === k ? { ...y, etiqueta: e.target.value } : y)) }))} />
                                    </td>
                                    {s.columnas.map((c, j) => (
                                        <td key={c.key}>{this.renderEditorCelda(s, i, f, k, c, j)}</td>
                                    ))}
                                    <td>
                                        <span style={{ display: "flex", gap: 2 }}>
                                            <ButtonItem lessTime type="default" size="small" icon={<ArrowUpOutlined />} disabled={k === 0} onClick={() => this.setSeccion(i, (x) => ({ filas: mover(x.filas, k, -1) }))} />
                                            <ButtonItem lessTime type="default" size="small" icon={<ArrowDownOutlined />} disabled={k === s.filas.length - 1} onClick={() => this.setSeccion(i, (x) => ({ filas: mover(x.filas, k, 1) }))} />
                                            <Tooltip title="Duplicar renglón">
                                                <ButtonItem lessTime type="default" size="small" blanco icon={<CopyOutlined />} onClick={() => this.agregarFila(i, k)} />
                                            </Tooltip>
                                            <ButtonItem lessTime type="default" size="small" rojo icon={<DeleteOutlined />} disabled={s.filas.length === 1} onClick={() => this.setSeccion(i, (x) => ({ filas: x.filas.filter((_, n) => n !== k) }))} />
                                        </span>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <ButtonItem lessTime type="dashed" icon={<PlusOutlined />} onClick={() => this.agregarFila(i)} style={{ marginTop: 8 }}>
                    Agregar renglón
                </ButtonItem>
            </DynamicCardForm>
        );
    }

    render() {
        const d = this.state.d;
        return (
            <div className="cmms-pagina">
                <PageHeader
                    title={this.state.id ? `Plantilla ${d.clave || d.nombre}` : "Nueva plantilla de certificado"}
                    subTitle={this.state.cambios ? <Tag color="gold">Sin guardar</Tag> : null}
                    onBack={this.salir}
                    backIcon={<ArrowLeftOutlined />}
                    style={{ border: "1px solid rgb(235, 237, 240)", backgroundColor: "white", marginBottom: 10, position: "sticky", top: 0, zIndex: 5 }}
                    extra={
                        <div style={{ display: "flex", gap: 6 }}>
                            <ButtonItem type="link" blanco onClick={() => this.setState({ openTour: true })}>
                                ¿Cómo funciona?
                            </ButtonItem>
                            <ButtonItem type="default" icon={<EyeOutlined />} onClick={() => this.setState({ vistaPrevia: true })}>
                                Vista previa
                            </ButtonItem>
                            <ButtonItem type="primary" icon={<SaveOutlined />} loading={this.state.guardando} onClick={this.guardar}>
                                Guardar
                            </ButtonItem>
                        </div>
                    }
                />
                <Spin spinning={this.state.cargando}>
                    <div className="cmms-pagina-cuerpo">
                        <Alert
                            type="info"
                            showIcon
                            style={{ marginBottom: 10 }}
                            message="Editar la plantilla no cambia los certificados ya emitidos: cada certificado guarda su propia copia."
                        />
                        <Row gutter={14}>
                            {this.renderDatos()}
                            {this.renderCamposEquipo()}
                            {d.secciones.map((s, i) => (s.tipo === "tabla" ? this.renderTabla(s, i) : this.renderChecklist(s, i)))}
                            <Col xs={24} style={{ marginBottom: 12, display: "flex", gap: 8 }}>
                                <ButtonItem lessTime type="dashed" icon={<UnorderedListOutlined />} onClick={() => this.set({ secciones: [...d.secciones, seccionChecklist()] })}>
                                    Agregar checklist (antes / después)
                                </ButtonItem>
                                <ButtonItem lessTime type="dashed" icon={<TableOutlined />} onClick={() => this.set({ secciones: [...d.secciones, seccionTabla()] })}>
                                    Agregar tabla de mediciones
                                </ButtonItem>
                            </Col>
                            <DynamicCardForm title="Resumen del estado (dictamen sugerido)" xs={24}>
                                <div className="cmms-ayuda">Al certificar se propone uno u otro según el resultado; el ingeniero lo puede ajustar.</div>
                                <Row gutter={12}>
                                    <Col xs={24} lg={12}>
                                        <div className="cmms-etiqueta-campo">Si todo cumple</div>
                                        <Input.TextArea rows={4} value={d.dictamenAprobado} onChange={(e) => this.set({ dictamenAprobado: e.target.value })} />
                                    </Col>
                                    <Col xs={24} lg={12}>
                                        <div className="cmms-etiqueta-campo">Si algo no cumple</div>
                                        <Input.TextArea rows={4} value={d.dictamenNoAprobado} onChange={(e) => this.set({ dictamenNoAprobado: e.target.value })} />
                                    </Col>
                                </Row>
                            </DynamicCardForm>
                        </Row>
                    </div>
                </Spin>
                <Modal
                    visible={!!this.state.pegar}
                    title="Pegar varias características"
                    onCancel={() => this.setState({ pegar: null })}
                    onOk={this.aplicarPegado}
                    okText="Agregar"
                    cancelText="Cancelar"
                >
                    <div style={{ fontSize: 12, color: "#7a8794", marginBottom: 6 }}>Una por renglón. Con “Grupo: texto” se llena el grupo. Se quitan los números del inicio.</div>
                    <Input.TextArea
                        rows={10}
                        value={this.state.pegar?.texto}
                        onChange={(e) => this.setState({ pegar: { ...this.state.pegar, texto: e.target.value } })}
                        placeholder={"Estado físico.\nNIBP: Estado de manguera y brazalete NIBP.\nAlarmas: Alarma audible y/o visual de batería baja."}
                    />
                </Modal>
                <ModalPdfCMMS visible={this.state.vistaPrevia} titulo="Vista previa del certificado" nombreArchivo={`Plantilla_${d.clave || "certificado"}.pdf`} generar={async () => this.vistaPrevia()} onClose={() => this.setState({ vistaPrevia: false })} />
                <TourItem
                    open={this.state.openTour}
                    onClose={() => this.setState({ openTour: false })}
                    steps={[
                        { title: "Datos", description: "Clave y nombre que se imprimen, vigencia en meses, para qué tipos de activo se propone y qué equipos patrón se sugieren.", target: null },
                        { title: "Checklist", description: "Características a inspeccionar. Al certificar cada una se marca antes y después del mantenimiento: cumple, no cumple o no aplica.", target: null },
                        {
                            title: "Tablas de mediciones",
                            description:
                                "Columnas de medición con su tolerancia (± % o ± unidades). Cada renglón trae su valor establecido (vacío = lo escribe el ingeniero, como las energías del desfibrilador) o un rango propio del manual (botón del engrane). Columnas Ok / Error para pruebas cualitativas y de dato fijo para Load, submodo, etc.",
                            target: null,
                        },
                        { title: "Vista previa", description: "Muestra el PDF tal como saldrá (vacío). Guarde cuando termine.", target: null },
                    ]}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(PlantillaCertificado);
